module.exports = __webpack_public_path__ + "media/images/gallery/gc_tab_off-bd775b6588778c3dc56dd4d695a1e98b.jpg";